import { useEffect } from 'react';

// ─── MODAL RICERCA E SELEZIONE ───────────────────────────────────────────────
function RicercaSelezioneModal({ onClose }: { onClose: () => void }) {
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as any);
    await fetch('https://readdy.ai/api/form/d6gs6rqu8ojn6g516jm0', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
    });
    setSubmitted(true);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-navy-50 rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-search-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Ricerca e Selezione</h2>
              <p className="text-xs text-gray-500">Compila il modulo per essere ricontattato</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6">
          {submitted ? (
            <div className="text-center py-12">
              <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4" style={{background:'#EEF2FF'}}>
                <i className="ri-check-line text-3xl" style={{color:'#1E3A5F'}}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Richiesta inviata!</h3>
              <p className="text-gray-600 text-sm">Il nostro team ti contatterà entro 24 ore lavorative.</p>
              <button onClick={onClose} className="mt-6 px-6 py-3 text-white text-sm font-medium rounded-full hover:opacity-90 transition-colors cursor-pointer whitespace-nowrap" style={{background:'#1E3A5F'}}>
                Chiudi
              </button>
            </div>
          ) : (
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Ragione Sociale *</label>
                  <input name="ragione_sociale" required type="text" placeholder="Es. Acme S.r.l." className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:border-transparent" style={{'--tw-ring-color':'#1E3A5F'} as any} />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Settore Aziendale *</label>
                  <select name="settore" required className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona settore</option>
                    <option>Ristorazione — Ristoranti, Pizzerie, Trattorie</option>
                    <option>Ristorazione — Fast Food &amp; Quick Service</option>
                    <option>Ristorazione — Catering &amp; Banqueting</option>
                    <option>Hotellerie — Hotel, Resort, Alberghi</option>
                    <option>Hotellerie — B&amp;B, Affittacamere, Ostelli</option>
                    <option>Bar, Caffetterie &amp; Pasticcerie</option>
                    <option>Stabilimenti Balneari &amp; Turismo Balneare</option>
                    <option>Servizi — Pulizie &amp; Sanificazione</option>
                    <option>Servizi — Portierato, Reception, Accoglienza</option>
                    <option>Servizi — Facility Management</option>
                    <option>Logistica — Magazzinieri &amp; Operatori di Magazzino</option>
                    <option>Logistica — Picking, Packing &amp; Movimentazione Merci</option>
                    <option>Trasporti — Autisti NCC &amp; Taxi</option>
                    <option>Trasporti — Corrieri &amp; Delivery</option>
                    <option>Trasporti — Autisti di Linea &amp; Rider</option>
                    <option>Altro</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Nome Referente *</label>
                  <input name="nome_referente" required type="text" placeholder="Nome e Cognome" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Ruolo in Azienda</label>
                  <input name="ruolo" type="text" placeholder="Es. HR Manager, CEO..." className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Email Aziendale *</label>
                  <input name="email" required type="email" placeholder="nome@azienda.it" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Telefono *</label>
                  <input name="telefono" required type="tel" placeholder="+39 06 000 0000" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Figura Professionale Ricercata *</label>
                  <input name="figura_ricercata" required type="text" placeholder="Es. Sviluppatore Senior, CFO..." className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Numero di Risorse</label>
                  <select name="numero_risorse" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona</option>
                    <option>1 risorsa</option>
                    <option>2-5 risorse</option>
                    <option>6-10 risorse</option>
                    <option>Più di 10</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Tipo di Contratto</label>
                  <select name="tipo_contratto" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona</option>
                    <option>Tempo Indeterminato</option>
                    <option>Tempo Determinato</option>
                    <option>Somministrazione</option>
                    <option>Collaborazione / Consulenza</option>
                    <option>Stage / Tirocinio</option>
                  </select>
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Tempistica di Inserimento</label>
                  <select name="tempistica" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona</option>
                    <option>Immediata</option>
                    <option>Entro 1 mese</option>
                    <option>Entro 3 mesi</option>
                    <option>Oltre 3 mesi</option>
                  </select>
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">Descrizione del Profilo e Requisiti</label>
                <textarea
                  name="descrizione_profilo"
                  rows={3}
                  maxLength={500}
                  placeholder="Descrivi le competenze richieste, l'esperienza necessaria, eventuali certificazioni..."
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none resize-none"
                  onChange={e => setCharCount(e.target.value.length)}
                />
                <p className="text-xs text-gray-400 text-right mt-1">{charCount}/500</p>
              </div>

              <div className="flex items-center gap-2">
                <input name="privacy" required type="checkbox" id="privacy-rs" className="w-4 h-4 cursor-pointer" />
                <label htmlFor="privacy-rs" className="text-xs text-gray-600 cursor-pointer">
                  Acconsento al trattamento dei dati personali ai sensi del GDPR *
                </label>
              </div>

              <button type="submit" className="w-full py-3 text-white text-sm font-semibold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap" style={{background:'#1E3A5F'}}>
                Invia Richiesta
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── MODAL ESTERNALIZZAZIONE ─────────────────────────────────────────────────
function EsternalizzazioneModal({ onClose }: { onClose: () => void }) {
  const [submitted, setSubmitted] = useState(false);
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as any);
    await fetch('https://readdy.ai/api/form/d6gs6rqu8ojn6g516jmg', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: data.toString(),
    });
    setSubmitted(true);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-team-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Esternalizzazione del Personale</h2>
              <p className="text-xs text-gray-500">Gestione completa delle risorse umane esterne</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6">
          <div className="grid grid-cols-3 gap-3 mb-6">
            {[
              { icon: 'ri-shield-check-line', title: 'Gestione Contratti', desc: 'Ci occupiamo di tutta la parte contrattuale e amministrativa' },
              { icon: 'ri-money-euro-circle-line', title: 'Payroll & Buste Paga', desc: 'Elaborazione paghe, contributi e adempimenti fiscali' },
              { icon: 'ri-customer-service-2-line', title: 'Supporto Continuo', desc: 'Account dedicato e assistenza operativa H24' },
            ].map((item, i) => (
              <div key={i} className="rounded-xl p-4 text-center" style={{background:'#F8F9FF'}}>
                <div className="w-8 h-8 flex items-center justify-center rounded-full mx-auto mb-2" style={{background:'#EEF2FF'}}>
                  <i className={`${item.icon} text-base`} style={{color:'#1E3A5F'}}></i>
                </div>
                <p className="text-xs font-semibold text-gray-800 mb-1">{item.title}</p>
                <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>

          {submitted ? (
            <div className="text-center py-10">
              <div className="w-16 h-16 flex items-center justify-center rounded-full mx-auto mb-4" style={{background:'#EEF2FF'}}>
                <i className="ri-check-line text-3xl" style={{color:'#1E3A5F'}}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Richiesta inviata!</h3>
              <p className="text-gray-600 text-sm">Ti contatteremo entro 24 ore lavorative con una proposta personalizzata.</p>
              <button onClick={onClose} className="mt-6 px-6 py-3 text-white text-sm font-medium rounded-full hover:opacity-90 transition-colors cursor-pointer whitespace-nowrap" style={{background:'#1E3A5F'}}>
                Chiudi
              </button>
            </div>
          ) : (
            <form data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Ragione Sociale *</label>
                  <input name="ragione_sociale" required type="text" placeholder="Es. Acme S.r.l." className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Settore</label>
                  <select name="settore" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona settore</option>
                    <option>Ristorazione — Ristoranti, Pizzerie, Trattorie</option>
                    <option>Ristorazione — Fast Food &amp; Quick Service</option>
                    <option>Ristorazione — Catering &amp; Banqueting</option>
                    <option>Hotellerie — Hotel, Resort, Alberghi</option>
                    <option>Hotellerie — B&amp;B, Affittacamere, Ostelli</option>
                    <option>Bar, Caffetterie &amp; Pasticcerie</option>
                    <option>Stabilimenti Balneari &amp; Turismo Balneare</option>
                    <option>Servizi — Pulizie &amp; Sanificazione</option>
                    <option>Servizi — Portierato, Reception, Accoglienza</option>
                    <option>Servizi — Facility Management</option>
                    <option>Logistica — Magazzinieri &amp; Operatori di Magazzino</option>
                    <option>Logistica — Picking, Packing &amp; Movimentazione Merci</option>
                    <option>Trasporti — Autisti NCC &amp; Taxi</option>
                    <option>Trasporti — Corrieri &amp; Delivery</option>
                    <option>Trasporti — Autisti di Linea &amp; Rider</option>
                    <option>Altro</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Nome Referente *</label>
                  <input name="nome_referente" required type="text" placeholder="Nome e Cognome" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Email *</label>
                  <input name="email" required type="email" placeholder="nome@azienda.it" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">Telefono *</label>
                  <input name="telefono" required type="tel" placeholder="+39 06 000 0000" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-700 mb-1.5">N° Dipendenti da Gestire</label>
                  <select name="numero_dipendenti" className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none cursor-pointer">
                    <option value="">Seleziona</option>
                    <option>1-5</option>
                    <option>6-20</option>
                    <option>21-50</option>
                    <option>51-100</option>
                    <option>Oltre 100</option>
                  </select>
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold text-gray-700 mb-2">Servizi Inclusi nel Pacchetto</p>
                <div className="rounded-xl p-4 border border-gray-100" style={{background:'#F8F9FF'}}>
                  <div className="grid grid-cols-2 gap-2">
                    {[
                      'Gestione Contratti di Lavoro',
                      'Elaborazione Buste Paga',
                      'Adempimenti Contributivi',
                      'Gestione Presenze e Ferie',
                      'Supporto Disciplinare',
                      'Temporary Management',
                      'Somministrazione Lavoro',
                      'Distacco di Personale',
                    ].map((s) => (
                      <div key={s} className="flex items-center gap-2">
                        <div className="w-5 h-5 flex items-center justify-center rounded-full flex-shrink-0" style={{background:'#EEF2FF'}}>
                          <i className="ri-check-line text-xs" style={{color:'#1E3A5F'}}></i>
                        </div>
                        <span className="text-xs text-gray-600">{s}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-xs font-semibold text-gray-700 mb-1.5">Note Aggiuntive</label>
                <textarea
                  name="note"
                  rows={3}
                  maxLength={500}
                  placeholder="Descrivi le tue esigenze specifiche..."
                  className="w-full border border-gray-200 rounded-lg px-4 py-2.5 text-sm focus:outline-none resize-none"
                  onChange={e => setCharCount(e.target.value.length)}
                />
                <p className="text-xs text-gray-400 text-right mt-1">{charCount}/500</p>
              </div>

              <div className="flex items-center gap-2">
                <input name="privacy" required type="checkbox" id="privacy-es" className="w-4 h-4 cursor-pointer" />
                <label htmlFor="privacy-es" className="text-xs text-gray-600 cursor-pointer">
                  Acconsento al trattamento dei dati personali ai sensi del GDPR *
                </label>
              </div>

              <button type="submit" className="w-full py-3 text-white text-sm font-semibold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap" style={{background:'#1E3A5F'}}>
                Richiedi Proposta Personalizzata
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── MODAL CONSULENZA STRATEGICA — SOLO INFORMATIVA ──────────────────────────
function ConsulenzaModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const servizi = [
    {
      icon: 'ri-building-2-line',
      label: 'Per le Aziende',
      color: '#1E3A5F',
      bg: '#EEF2FF',
      items: [
        { icon: 'ri-percent-line', text: 'Recupero crediti fiscali e agevolazioni' },
        { icon: 'ri-bar-chart-line', text: 'Ottimizzazione del carico fiscale aziendale' },
        { icon: 'ri-funds-line', text: 'Pianificazione finanziaria strategica' },
        { icon: 'ri-scissors-cut-line', text: 'Analisi e riduzione dei costi operativi' },
      ],
    },
    {
      icon: 'ri-user-heart-line',
      label: 'Per i Dipendenti',
      color: '#B8860B',
      bg: '#FFF8E7',
      items: [
        { icon: 'ri-wallet-3-line', text: 'Ottimizzazione delle risorse finanziarie personali' },
        { icon: 'ri-calendar-check-line', text: 'Pianificazione previdenziale e pensionistica' },
        { icon: 'ri-shield-star-line', text: 'Coperture assicurative su misura' },
        { icon: 'ri-gift-line', text: 'Welfare aziendale e benefit fiscali' },
      ],
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-line-chart-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Consulenza Strategica &amp; Finanziaria</h2>
              <p className="text-xs text-gray-500">Ottimizzazione fiscale e finanziaria per aziende e dipendenti</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-5">
          {/* Banner incluso in fattura */}
          <div className="flex items-center gap-3 rounded-xl px-5 py-4" style={{background:'linear-gradient(135deg,#1E3A5F,#2C5282)'}}>
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
              <i className="ri-award-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-white text-sm font-semibold">Servizio incluso nella fattura finale</p>
              <p className="text-white/75 text-xs">Nessun costo aggiuntivo — la consulenza è compresa nel nostro pacchetto</p>
            </div>
          </div>

          {/* Due colonne servizi */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {servizi.map((col, i) => (
              <div key={i} className="rounded-xl p-5 border border-gray-100">
                <div className="flex items-center gap-2 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full" style={{background: col.bg}}>
                    <i className={`${col.icon} text-base`} style={{color: col.color}}></i>
                  </div>
                  <span className="text-sm font-bold text-gray-800">{col.label}</span>
                </div>
                <ul className="space-y-3">
                  {col.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5" style={{background: col.bg}}>
                        <i className={`${item.icon} text-xs`} style={{color: col.color}}></i>
                      </div>
                      <span className="text-sm text-gray-600 leading-snug">{item.text}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Perché sceglierci */}
          <div className="rounded-xl p-5" style={{background:'#F8F9FF'}}>
            <p className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-3">Perché affidarsi a PM Resources</p>
            <div className="grid grid-cols-3 gap-3 text-center">
              {[
                { icon: 'ri-time-line', val: '48h', label: 'Prima risposta' },
                { icon: 'ri-thumb-up-line', val: '100%', label: 'Personalizzato' },
                { icon: 'ri-file-list-3-line', val: '0€', label: 'Costo aggiuntivo' },
              ].map((stat, i) => (
                <div key={i}>
                  <div className="w-8 h-8 flex items-center justify-center rounded-full mx-auto mb-1" style={{background:'#EEF2FF'}}>
                    <i className={`${stat.icon} text-sm`} style={{color:'#1E3A5F'}}></i>
                  </div>
                  <p className="text-lg font-bold" style={{color:'#1E3A5F'}}>{stat.val}</p>
                  <p className="text-xs text-gray-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="pt-2 border-t border-gray-100 flex items-center justify-between">
            <p className="text-xs text-gray-500">Per richiedere una consulenza contattaci direttamente</p>
            <button
              onClick={onClose}
              className="px-6 py-2.5 text-white text-sm font-semibold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
              style={{background:'#1E3A5F'}}
            >
              Contattaci
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── MODAL FORMAZIONE PROFESSIONALE — SOLO INFORMATIVA ───────────────────────
function FormazioneModal({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  const corsi = [
    {
      cat: 'Sicurezza sul Lavoro — Obbligatoria',
      icon: 'ri-shield-check-line',
      badge: 'Obbligatorio',
      badgeColor: '#B8860B',
      badgeBg: '#FFF8E7',
      items: [
        'Formazione generale e specifica D.Lgs 81/08',
        'Primo Soccorso Aziendale (D.M. 388/2003)',
        'Antincendio — Rischio Basso / Medio / Alto',
        'Aggiornamento periodico RSPP e RLS',
        'Formazione Preposti e Dirigenti',
        'Sicurezza per lavoratori somministrati',
      ],
    },
    {
      cat: 'Formazione Obbligatoria per Settore',
      icon: 'ri-government-line',
      badge: 'Obbligatorio',
      badgeColor: '#B8860B',
      badgeBg: '#FFF8E7',
      items: [
        'HACCP — Igiene degli alimenti (Reg. CE 852/2004)',
        'Movimentazione manuale dei carichi',
        'Uso di attrezzatura e DPI',
        'Formazione per carrellisti e gruisti',
        'Lavori in quota e ponteggi',
        'Ambienti confinati e spazi ristretti',
      ],
    },
    {
      cat: 'Ristorazione & Hospitality',
      icon: 'ri-restaurant-line',
      badge: 'Specializzato',
      badgeColor: '#1E3A5F',
      badgeBg: '#EEF2FF',
      items: [
        'HACCP avanzato per operatori di cucina',
        'Gestione igienica della sala e del bar',
        'Allergenica e sicurezza alimentare',
        'Accoglienza e customer experience',
        'Gestione del personale in sala',
        'Normativa igienico-sanitaria per la ristorazione',
      ],
    },
    {
      cat: 'Privacy & Compliance',
      icon: 'ri-lock-password-line',
      badge: 'Obbligatorio',
      badgeColor: '#B8860B',
      badgeBg: '#FFF8E7',
      items: [
        'GDPR — Protezione dei dati personali',
        'Formazione per Responsabili del Trattamento',
        'Cybersecurity Awareness aziendale',
        'Antiriciclaggio (D.Lgs 231/2007)',
        'Codice Etico e Modello 231',
      ],
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 bg-white border-b border-gray-100 px-8 py-5 flex items-center justify-between rounded-t-2xl z-10">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
              <i className="ri-graduation-cap-line text-xl" style={{color:'#1E3A5F'}}></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-900">Formazione Professionale</h2>
              <p className="text-xs text-gray-500">Corsi obbligatori certificati e formazione specializzata</p>
            </div>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer">
            <i className="ri-close-line text-gray-500 text-xl"></i>
          </button>
        </div>

        <div className="px-8 py-6 space-y-4">
          {/* Banner */}
          <div className="flex items-center gap-3 rounded-xl px-5 py-4" style={{background:'linear-gradient(135deg,#1E3A5F,#2C5282)'}}>
            <div className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 flex-shrink-0">
              <i className="ri-medal-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-white text-sm font-semibold">Corsi certificati e riconosciuti a norma di legge</p>
              <p className="text-white/75 text-xs">Eroghiamo formazione in presenza, online e in modalità blended su tutto il territorio nazionale</p>
            </div>
          </div>

          {/* Griglia corsi */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {corsi.map((cat, i) => (
              <div key={i} className="rounded-xl p-5 border border-gray-100">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full" style={{background:'#EEF2FF'}}>
                      <i className={`${cat.icon} text-xs`} style={{color:'#1E3A5F'}}></i>
                    </div>
                    <span className="text-xs font-bold text-gray-800">{cat.cat}</span>
                  </div>
                  <span className="text-xs font-semibold px-2 py-0.5 rounded-full whitespace-nowrap" style={{color: cat.badgeColor, background: cat.badgeBg}}>
                    {cat.badge}
                  </span>
                </div>
                <ul className="space-y-1.5">
                  {cat.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2">
                      <i className="ri-arrow-right-s-line text-xs mt-0.5 flex-shrink-0" style={{color:'#B8860B'}}></i>
                      <span className="text-xs text-gray-600 leading-snug">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Modalità erogazione */}
          <div className="rounded-xl p-5" style={{background:'#F8F9FF'}}>
            <p className="text-xs font-bold text-gray-700 uppercase tracking-wider mb-3">Modalità di erogazione</p>
            <div className="grid grid-cols-3 gap-3 text-center">
              {[
                { icon: 'ri-map-pin-2-line', label: 'In Presenza', sub: 'Presso la vostra sede' },
                { icon: 'ri-computer-line', label: 'Online / E-learning', sub: 'Piattaforma certificata' },
                { icon: 'ri-refresh-line', label: 'Blended', sub: 'Misto presenza + online' },
              ].map((m, i) => (
                <div key={i} className="flex flex-col items-center">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full mb-2" style={{background:'#EEF2FF'}}>
                    <i className={`${m.icon} text-sm`} style={{color:'#1E3A5F'}}></i>
                  </div>
                  <p className="text-xs font-semibold text-gray-800">{m.label}</p>
                  <p className="text-xs text-gray-500">{m.sub}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="pt-2 border-t border-gray-100 flex items-center justify-between">
            <p className="text-xs text-gray-500">Per informazioni e preventivi contattaci</p>
            <button
              onClick={onClose}
              className="px-6 py-2.5 text-white text-sm font-semibold rounded-full hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
              style={{background:'#1E3A5F'}}
            >
              Contattaci
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── EXPORT ───────────────────────────────────────────────────────────────────
export { RicercaSelezioneModal, EsternalizzazioneModal, ConsulenzaModal, FormazioneModal };
